import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { userPointValidation } from './validation'
import dayjs from 'dayjs'

export const useUserPointForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(userPointValidation()),
    initialValues: {
      date: new Date(),
      value: 0,
      method: 'increase',
      type: ''
    },
    transformValues: (values) => {
      return {
        date: dayjs(values.date).format('YYYY-MM-DD HH:mm:ss'),
        value: Number(values.value),
        type: values.type,
      }
    }
  })
}

